import React, { useState, useEffect, useContext } from "react";
import organisms from "../../../components/organisms";
import Wrapper from "../../../components/common/Wrapper/Wrapper";
import service from "../../../api/services";
import { HeaderHeading } from "../../../Context";
import constant from "../../../constants/constant";
import { useSearchParams } from "react-router-dom";
import { getParams } from "../../../constants/utils";
import { useToasts } from "react-toast-notifications";
import molecules from "../../../components/molecules";
import atoms from "../../../components/atoms";

const { Brand } = organisms
const { ConfirmationModal, CreateModal } = molecules
const { Input } = atoms;

const Index = () => {
    // const url = window.location.href;
    // const unrecognized = url.split('/').pop() || '';
    const { addToast } = useToasts()
    const [searchParams] = useSearchParams();
    const [typeValue, setTypeValue] = useState<any>(getParams('brand-type'))
    const { setHeader }: any = useContext(HeaderHeading);
    const [storeBrandList, setStoreBrandList] = useState();
    const [isOpen, setIsOpen] = useState<string>('');
    const [brandId, setBrandId] = useState<string>('');
    const [ecomDiscount, setEcomDiscount] = useState<string>('');
    const [error, setError] = useState<string>('')

    useEffect(() => {
        setTypeValue(getParams('brand-type'))
    }, [searchParams])

    const getStoreBrandList = async () => {
        try {
            const response = await service.brandService?.brandList({ brand_category: typeValue })
            if (response.status === 200) {
                setStoreBrandList(response?.data)
            }
        } catch (error) {
            console.error('error', error)
        }
    }



    const deleteBrand = async (id: string) => {
        try {
            let response = await service.brandService.deleteBrand(id)
            if (response?.status === 200 || response?.status === 201) {
                getStoreBrandList()
                addToast(response?.data?.message, {
                    appearance: 'success',
                    autoDismiss: true,
                    autoDismissTimeout: 3000,
                });
            }
        } catch (error: any) {
            addToast(error?.response?.data?.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    }

    const handleEcommerceStatus = async (id: string) => {
        try {
            let response = await service.brandService.onlineStatus(id)
            if (response?.status === 200 || response?.status === 201) {
                getStoreBrandList()
                addToast(response?.data?.message, {
                    appearance: 'success',
                    autoDismiss: true,
                    autoDismissTimeout: 3000,
                });
            }
        } catch (error: any) {
            addToast(error?.response?.data?.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    };

    //function for edit the brand
    const editBrand = async () => {
        if (!ecomDiscount) {
            setError('Brand discount is required')
            return
        }

        const payload = {
            ecom_discount: Number(ecomDiscount)
        }
        try {
            const response = await service.brandService.editBrandDiscount(payload, brandId);
            if (response?.status === 200 || response?.status === 201) {
                getStoreBrandList();
                addToast(response?.data?.message, {
                    appearance: 'success',
                    autoDismiss: true,
                    autoDismissTimeout: 3000,
                });
                setIsOpen('');
                setError('');
                setEcomDiscount('');
            }
        } catch (error: any) {
            console.error(error);
            addToast(error?.response?.data?.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
            setIsOpen('')
        }
    }
    // end


    useEffect(() => {
        setHeader("Brand")
        getStoreBrandList()
    }, [typeValue])

    return (
        <Wrapper>
            <Brand
                storeBrandList={storeBrandList}
                unrecognized={typeValue == constant.BRAND_CATEGORY[0].value}
                deleteBrand={(id: string) => { setBrandId(id); setIsOpen('delete') }}
                handleEcommerceStatus={(id: string) => handleEcommerceStatus(id)}
                handleEditBrand={(id: string,brand_discount:string) => { setBrandId(id); setIsOpen('edit'); setEcomDiscount(brand_discount) }}
            />
            {/* brand discount edit model */}
            {(isOpen === 'edit') &&
                <CreateModal
                    show={!!isOpen}
                    header={"Update Brand Discount"}
                    handleSubmit={() => editBrand()}
                    submitBtnText={"Update"}
                    onHide={() => setIsOpen('')}
                >
                    <Input
                        label={"Brand Discount"}
                        placeholder={"Enter Brand Discount"}
                        type="string"
                        value={ecomDiscount}
                        errors={error}
                        onChange={(e: any) => e.target.value<101 && setEcomDiscount(e.target.value) }
                    />
                </CreateModal>
            }
            {/* end */}

            {/* delete confirm model */}
            {(isOpen === 'delete') && <ConfirmationModal
                show={!!isOpen}
                handleConfirmItem={() => deleteBrand(brandId)}
                onHide={() => setIsOpen('')}
                message={"delete this brand"}
            />}
            {/* end */}
        </Wrapper>
    )
}

export default Index